import React, { useEffect, useState } from "react";
import {
  Form,
  InputGroup,
  Table,
  Badge,
  Button,
  Card,
  Row,
  Col,
  Alert,
} from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import {
  FaFileAlt,
  FaDownload,
  FaUser,
  FaClock,
  FaShieldAlt,
  FaEdit,
  FaPlus,
  FaTrash,
  FaSignInAlt,
  FaCheck,
  FaTimes,
  FaExclamationTriangle,
  FaInfoCircle,
  FaFilter,
  FaCalendarAlt,
  FaPrint,
} from "react-icons/fa";
import SplitPane from "react-split-pane";
import UseToggle from "../../../Hooks/UseToggle";
import AuditDetail from "./AuditTrailComponent/AuditDetail";
import AuditExport from "./AuditTrailComponent/AuditExport";
import { studyOnboardingService } from "../../../APIServices/studyOnboarding";
import Moment from "react-moment";
import { useParams } from "react-router";
import Pagination from "../../Pagination";

const AuditTrail = ({ onMouseDown, tableRef }) => {
  const [searchData, setSearchData] = useState("");
  const [selectedAudit, setSelectedAudit] = useState(null);
  const [entityFilter, setEntityFilter] = useState("");
  const [actionFilter, setActionFilter] = useState("");
  const [userFilter, setUserFilter] = useState("");
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [loading, setLoading] = useState(false);
  const toggles = UseToggle();

  const [activityLoader, setActivityLoader] = useState(false);
  const [EIWRSActivity, setEIWRSActivity] = useState([]);
  const [EIWRSActivityCount, setEIWRSActivityCount] = useState(0);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(EIWRSActivityCount / itemsPerPage);

  const getStudyAllEIWRSAuditTrialList = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAllEIWRSAuditTrialList(
      studyId,
      "all",
      "eiwrs",
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setEIWRSActivity(data?.data || []);
    setEIWRSActivityCount(data?.count || 0);
    setActivityLoader(false);
  };
  useEffect(() => {
    getStudyAllEIWRSAuditTrialList(pageNumber, itemsPerPage);
  }, [pageNumber, itemsPerPage]);

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-2">
          <div className="position-relative">
            <CiSearch
              className="position-absolute"
              style={{
                left: 10,
                top: "50%",
                transform: "translateY(-50%)",
                color: "#6c757d",
              }}
            />
            <Form.Control
              placeholder="Search audit trail..."
              value={searchData}
              disabled
              onChange={(e) => setSearchData(e.target.value)}
              className="ps-4"
              style={{ width: 220 }}
              size="sm"
            />
          </div>
          <Form.Select
            className="w-auto"
            size="sm"
            style={{ minWidth: 120 }}
            value={entityFilter}
            disabled
            onChange={(e) => setEntityFilter(e.target.value)}
          >
            <option value="">All entities</option>
          </Form.Select>
          <Form.Select
            size="sm"
            className="w-auto"
            style={{ minWidth: 120 }}
            value={actionFilter}
            disabled
            onChange={(e) => setActionFilter(e.target.value)}
          >
            <option value="">All actions</option>
          </Form.Select>
          <Form.Select
            size="sm"
            className="w-auto"
            style={{ minWidth: 120 }}
            value={userFilter}
            disabled
            onChange={(e) => setUserFilter(e.target.value)}
          >
            <option value="">All users</option>
          </Form.Select>
          <button disabled className="updateProfile">
            <FaDownload className="me-1" size={12} />
            Export
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="p-2 border-bottom" style={{ backgroundColor: "#f8f9fa" }}>
        <Row className="g-2">
          <Col xs={6} md={3}>
            <Card className="app-card">
              <Card.Body className="p-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="text-muted small">Total Records</div>
                    <div className="fw-bold fs-5">{EIWRSActivityCount || 0}</div>
                  </div>
                  <FaFileAlt className="text-primary opacity-50" size={24} />
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={6} md={3}>
            <Card className="app-card">
              <Card.Body className="p-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="text-muted small">Today's Activity</div>
                    <div className="fw-bold fs-5">{0}</div>
                  </div>
                  <FaClock className="text-warning opacity-50" size={24} />
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={6} md={3}>
            <Card className="app-card">
              <Card.Body className="p-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="text-muted small">E-Signatures</div>
                    <div className="fw-bold fs-5">{0}</div>
                  </div>
                  <FaCheck className="text-success opacity-50" size={24} />
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={6} md={3}>
            <Card className="app-card">
              <Card.Body className="p-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="text-muted small">System Events</div>
                    <div className="fw-bold fs-5">{0}</div>
                  </div>
                  <FaInfoCircle className="text-info opacity-50" size={24} />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Audit Table */}
      <SplitPane
        split="vertical"
        minSize={20}
        style={{ height: "calc(100vh - 300px)" }}
        className="position-relative"
        defaultSize={"100%"}
      >
        {loading ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            Loading...
          </div>
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ minWidth: 100 }}
                  >
                    TIMESTAMP
                  </th>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 1)}
                    style={{ minWidth: 140 }}
                  >
                    USER
                  </th>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 2)}
                    style={{ minWidth: 100 }}
                  >
                    ACTIVITY TYPE
                  </th>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 3)}
                    style={{ minWidth: 140 }}
                  >
                    ACTIVITIES
                  </th>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 4)}
                    style={{ minWidth: 180 }}
                  >
                    PREVIOUS VALUE
                  </th>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 5)}
                    style={{ minWidth: 100 }}
                  >
                    CURRENT VALUE
                  </th>
                </tr>
              </thead>
              <tbody>
                {EIWRSActivityCount === 0 ? (
                  <tr>
                    <td colSpan="9" className="text-center text-muted py-4">
                      No audit records found.
                    </td>
                  </tr>
                ) : (
                  EIWRSActivity.map((item, index) => (
                    <tr key={item.id || index}>
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {item.createdAt}
                        </Moment>
                      </td>
                      <td>
                        <div className="fw-semibold small">{item?.fullName}</div>
                      </td>
                      <td>
                        <span className="text-uppercase fw-semibold small">{item?.actionType}</span>
                      </td>
                      <td>
                        <span className="small">{item.activities}</span>
                      </td>
                      <td>
                        <span className="small">{item.previousValue || "—"}</span>
                      </td>
                      <td>
                        <span className="small">{item.updatedValue || "—"}</span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={EIWRSActivityCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>

      {/* Modals */}
      <AuditDetail
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        Title="Audit Record Details"
      />

      <AuditExport
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        Title="Export Audit Trail"
      />
    </>
  );
};

export default AuditTrail;
